var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.75A2.25 2.25 0 0 0 2.75 5v2.91a.75.75 0 0 1-1.5 0V5A3.75 3.75 0 0 1 5 1.25h2.91a.75.75 0 0 1 0 1.5H5ZM15.34 2a.75.75 0 0 1 .75-.75H19A3.75 3.75 0 0 1 22.75 5v2.91a.75.75 0 0 1-1.5 0V5A2.25 2.25 0 0 0 19 2.75h-2.91a.75.75 0 0 1-.75-.75ZM2 15.34a.75.75 0 0 1 .75.75V19A2.25 2.25 0 0 0 5 21.25h2.91a.75.75 0 0 1 0 1.5H5A3.75 3.75 0 0 1 1.25 19v-2.91a.75.75 0 0 1 .75-.75Zm20 0a.75.75 0 0 1 .75.75V19A3.75 3.75 0 0 1 19 22.75h-2.91a.75.75 0 0 1 0-1.5H19A2.25 2.25 0 0 0 21.25 19v-2.91a.75.75 0 0 1 .75-.75Z"
  })));
};
export default SvgEnterFullscreen;